module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detailsView flexRow"
  }, [_c('day-summary', {
    staticClass: "daySummary",
    attrs: {
      "categories": _vm.categories
    }
  }), _vm._v(" "), (_vm.isBetaUser && !_vm.isMobile()) ? _c('the-line', {
    attrs: {
      "categories": _vm.categories
    }
  }) : _vm._e(), _vm._v(" "), _c('category-details', {
    staticClass: "categoryDetailsSummary",
    attrs: {
      "categoryId": _vm.category.id
    }
  }), _vm._v(" "), _c('quotes', {
    staticClass: "quotes"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0928b90d!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/DetailsView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0928b90d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/DetailsView.vue
// module chunks = 0